import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { QueryParamsService } from 'src/app/services/query-params.service';

@Component({
  selector: 'app-parameters-products',
  templateUrl: './parameters-products.component.html',
  styleUrls: ['./parameters-products.component.scss']
})
export class ParametersProductsComponent implements OnInit {
  permissionType = PermissionTypeEnum;
  history = 0;

  constructor(
    private authService: AuthenticationService,
    private queryParamsService: QueryParamsService
  )
  {
    var permissions = authService.getPermissions();
  }

  ngOnInit(): void {
    this.history = this.queryParamsService.getNumberParam("history", 0);
  }

  updateIndexParam(value: any) {
    if (value==this.history) {
      return;
    }
    this.queryParamsService.setParams({
      history: value,
    });
  }
}
